import React from 'react';
import { Button, Loader } from 'hfs-common-ui';
import FormattedMessageWrapper from '~/components/views/FormattedMessageWrapper/FormattedMessageWrapper';
import { ModalButtonConfig } from '../../types';
import * as S from './styled';

interface ModalActionsProps {
  actions?: React.ReactNode;
  actionButtons: ModalButtonConfig[];
  isMobile: boolean;
  id?: string;
  infoOrErrorOrWarning?: boolean;
}

const ModalActions = ({
  actions,
  actionButtons,
  isMobile,
  id,
  infoOrErrorOrWarning,
}: ModalActionsProps) => {
  if (actions) {
    return (
      <S.ModalActionDiv
        id={id ? `${id}-modal-action` : 'modal-action'}
        data-testid={id ? `${id}-modal-action` : 'modal-action'}
        $infoOrErrorOrWarning={infoOrErrorOrWarning}
      >
        <S.ActionContainerMessage id="action-message-container" />
        {actions}
      </S.ModalActionDiv>
    );
  }
  if (actionButtons && actionButtons.length > 0) {
    return (
      <S.ModalActionDiv
        id={id ? `${id}-modal-action` : 'modal-action'}
        data-testid={id ? `${id}-modal-action` : 'modal-action'}
        $infoOrErrorOrWarning={infoOrErrorOrWarning}
      >
        <S.ActionContainerMessage id="action-message-container" />
        <S.ActionBtnsContainer
          id={id ? `${id}-modal-action-btn-container` : 'modal-action-btn-container'}
        />
        {actionButtons.map((btn, index) => {
          const { label: labelLang, idSuffix, key, size, loading, ...btnProps } = btn;
          if (
            !infoOrErrorOrWarning &&
            isMobile &&
            btnProps.variant === 'secondary' &&
            actionButtons.length > 1
          ) {
            return null;
          }
          return (
            <Button key={key} size={!infoOrErrorOrWarning ? size : 'small'} {...btnProps}>
              {loading && <Loader size="small" variant="white" padding={false} />}
              <span id={id ? `${id}-action-btn-${idSuffix ?? index}` : `action-btn-${index}`}>
                <FormattedMessageWrapper langKey={labelLang.key} values={labelLang.values} />
              </span>
            </Button>
          );
        })}
      </S.ModalActionDiv>
    );
  }
  return null;
};

export default ModalActions;
